export type UpsellOption = {
  id: string
  title: string
  subtitle: string
  price: number
  originalPrice?: number
  badge?: string
  highlight?: string
  variantId: string
  quantity: number
  breakdown?: string
  pricePerPiece?: string
  checks?: string[]
}

export const upsellOptions: UpsellOption[] = [
  {
    id: 'base',
    title: 'Pack Pro-Series · 30 piezas',
    subtitle: 'El arsenal básico para no regresar en blanco. Los colores exactos que jalan en cualquier presa de México.',
    price: 399,
    variantId: '48249833226498',
    quantity: 1,
  },
  {
    id: 'doble',
    title: 'Doble Arsenal · 60 piezas',
    subtitle: 'Para salidas de fin de semana. La jugada inteligente para no quedarte corto cuando están picando fuerte.',
    price: 749,
    originalPrice: 799,
    badge: 'Envío gratis',
    variantId: '48322106818818',
    quantity: 1,
    breakdown: 'Pitbull 20 · Ghost 20 · Cangrejo 20',
    pricePerPiece: '$12.48 c/u',
  },
  {
    id: 'triple',
    title: 'Kit de las Tres Presas · 90 pzas',
    subtitle: 'La Masterclass del Color. Cubre aguas turbias, claras y días nublados. Si con esto no pescas, mejor vende la lancha.',
    price: 999,
    originalPrice: 1197,
    badge: 'Envío gratis',
    highlight: 'EL MÁS ELEGIDO',
    variantId: '48322141094146',
    quantity: 1,
    breakdown: 'Pitbull 30 · Ghost 30 · Cangrejo 30',
    pricePerPiece: '$11.10 c/u',
    checks: ['Aguas turbias y claras', 'Ahorras $198', 'Envío gratis'],
  },
]

export const getCheckoutUrl = (variantId: string, quantity: number) =>
  `https://charlybaits.com/cart/${variantId}:${quantity}`

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/rkzebcR8DeuNPnnmw64HEu/WhatsApp_Image_2026-07-01_at_2.10.01_PM.jpg'

export const lures = [
  {
    name: 'PITBULL',
    tag: 'Creature / Cola vibradora',
    image:
      'https://cdn.magicpatterns.com/uploads/c4DJt6K9p7hzPpHC9uTDnV/perro.png',
    copy: 'Cola curva que patalea con el mínimo movimiento de tu muñeca. La cola manda vibración en abanico: la lobina no lo ve, lo siente venir. Instinto puro.',
  },
  {
    name: 'GHOST',
    tag: 'Stick worm / Caída herida',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/56f1a39b-47fb-429e-bb49-b4ccc132084d.jpg',
    copy: 'Cae de lado a lado, como algo que ya se rindió. Polímero cargado de sal y aroma que aguanta mordida tras mordida sin partirse en dos — el pez lo sujeta, no lo escupe. En Watermelon Seed, Watermelon Red, Black Blue y Ozark Smoke.',
  },
  {
    name: 'CANGREJO',
    tag: 'Craw / Pinzas al aire',
    image:
      'https://cdn.magicpatterns.com/uploads/n54eNow36ysAxY1e4FxN3Q/cangrejos.png',
    copy: 'Pinzas huecas que flotan y se abren en cuanto lo dejas quieto en el fondo. Postura de defensa: la lobina grande no aguanta ver un cangrejo retándola.',
  },
]

export const bullets = [
  {
    kicker: 'La cola que despierta muertos',
    text: 'El Pitbull vibra en frecuencia baja incluso en recogida lenta. Ese golpeteo entra por la línea lateral del pez y dispara el ataque reflejo: la lobina apática muerde antes de decidir si tiene hambre.',
  },
  {
    kicker: 'Aguanta más de 5 picadas',
    text: 'Los Ghost están formulados con un polímero elástico de alta memoria: se estiran, regresan y siguen ahí después de 5 mordidas. Menos tiempo reponiendo señuelo, más tiempo con el señuelo en el agua.',
  },
  {
    kicker: 'Colores "secretos" de presa mexicana',
    text: 'Probados a mediodía en El Salto, en agua turbia de Aguamilpa y en el cristal de Comedero. Sabemos qué flake desaparece y qué vientre se sigue viendo cuando el agua parece atole.',
  },
  {
    kicker: 'Aroma integrado, no untado',
    text: 'El atractante va dentro de la mezcla, no en una capa que se lava al tercer lance. El pez lo sujeta un segundo más: ese segundo es tu clavada.',
  },
  {
    kicker: 'Textura suave que engaña al tacto',
    text: 'Blandos al morder para que el pez no lo suelte, firmes al armar para que no se desgarren en el anzuelo. Ese balance es la ingeniería, no el plástico.',
  },
  {
    kicker: 'Hechos a mano en México',
    text: 'Moldeados lote por lote, revisados pieza por pieza. Sin colas chuecas, sin rebabas que arruinen el nado, sin cajas que pasaron seis meses en un contenedor.',
  },
]

export const packContents = [
  'Pitbull — 10 piezas',
  'Ghost — 10 piezas',
  'Cangrejo — 10 piezas',
]

export const packColors = [
  'Watermelon Seed',
  'Watermelon Red',
  'Black Blue',
  'Ozark Smoke',
]

export const socialProofImages = [
  'https://cdn.magicpatterns.com/uploads/gcWFEDpu1ZuuRvwrKC54eh/testimonio_1.jpg',
  'https://cdn.magicpatterns.com/uploads/or4hf9WA99h2CSphDUTAhz/testimonio_2.jpg',
  'https://cdn.magicpatterns.com/uploads/a32oCvVoepobNSQsaaDJCv/testimonio_3.jpg',
]

export const faqs = [
  {
    q: '¿Cuánto tarda en llegar?',
    a: 'Llega en 3-5 días hábiles a cualquier parte de México. Los pedidos salen de nuestro taller en 24 horas tras confirmar tu compra.',
  },
  {
    q: '¿Cuánto cuesta el envío?',
    a: 'El envío tiene un costo fijo de $99 MXN a todo el país, sin importar el volumen de tu pedido.',
  },
  {
    q: '¿Cómo funciona la garantía de 2 salidas?',
    a: 'Tienes dos jornadas de pesca completas para probar los señuelos. Si no sientes la vibración o no tienes ataques, nos contactas con una foto de tu pack. Te devolvemos tu dinero y te quedas con los señuelos usados. Sin letras chiquitas.',
  },
  {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos tarjetas de crédito y débito, pago en efectivo en tiendas OXXO y transferencias interbancarias (SPEI). Tu pago es 100% seguro.',
  },
]
